module.exports = __webpack_public_path__ + "static/media/1027862.c6e2c8a0.png";